import { IIdentifiable } from '@/common/models/models'
import { CollaborationEntryType, ICollaborationEntryType } from '@/common/models/data/dashboard/collaboration/collaboration-entry-type'

interface ICollaborationEntry extends IIdentifiable {
    type_id: number
    name: string
    logo: string
    link: string

    type?: ICollaborationEntryType
}

class CollaborationEntry implements ICollaborationEntry {
    id = 0
    type_id = 0
    name = ''
    logo = ''
    link = ''

    type: ICollaborationEntryType = new CollaborationEntryType()

    file: File | null = null

    constructor (dto?: ICollaborationEntry) {
        if (dto) {
            this.id =  dto.id
            this.type_id =  dto.type_id
            this.name =  dto.name
            this.logo =  dto.logo
            this.link =  dto.link

            if (dto.type) {
                this.type = new CollaborationEntryType(dto.type)
            }
        }
    }
}

export {
    ICollaborationEntry, CollaborationEntry
}
